import type React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Markdown } from '@mentimeter/ragnar-ui/markdown';
import { Text } from '@mentimeter/ragnar-ui/text';
import type { ReactNode } from 'react';
import { PopoverBody, PopoverHeader } from '../../components/Popover';

export function RoleUpgradeDisabledPopoverContentNew({
  title,
  description,
  message,
  width = '300px',
  badge,
  onDismissClick,
}: {
  title: string;
  description: ReactNode | string;
  message: string;
  width?: string;
  badge?: 'pro' | 'basic' | undefined;
  onDismissClick: () => void;
}) {
  return (
    <Box width={width}>
      <PopoverHeader badge={badge} onDismissClick={onDismissClick}>
        {title}
      </PopoverHeader>
      <PopoverBody data-testid="request-role-upgrade-popover-disabled">
        <Text mb={2}>{description}</Text>
        <Box color="textWeak" mb={2}>
          <Markdown>{message}</Markdown>
        </Box>
      </PopoverBody>
    </Box>
  );
}
